import { FAIconName, Icon, Text } from "@/ui/core";
import { Box, HStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface ViewAllCardProps extends ViewWithTestID {
  onPress: () => void;
}

const ViewAllCard = ({ onPress, testID }: ViewAllCardProps) => {
  const baseTestID = joinTestIDs(testID, "view-all");

  return (
    <Box
      alignItems="center"
      backgroundColor={ColorToken.Primary10}
      borderBottomLeftRadius={16}
      borderBottomRightRadius={40}
      borderTopLeftRadius={16}
      borderTopRightRadius={40}
      justifyContent="center"
      onPress={onPress}
      padding={18}
      testID={baseTestID}
    >
      <HStack alignItems="center" gap={6}>
        <Text
          color={ColorToken.Primary100}
          testID={joinTestIDs(baseTestID, "text")}
          variant="captionMedium"
        >
          View all
        </Text>
        <Icon
          color={ColorToken.Primary100}
          name={FAIconName.ChevronRight}
          size="sm"
          testID={baseTestID}
        />
      </HStack>
    </Box>
  );
};

export type { ViewAllCardProps };
export default ViewAllCard;
